export default [
    { name: 'Learning Space', value: 'LEARNING_SPACE' },
    { name: 'Person transportation', value: 'PERSON_TRANSPORTATION' },
    { name: 'Cartage', value: 'CARTAGE' },
];
